import { render, staticRenderFns } from "./SurveyInfoSurveyPreference.vue?vue&type=template&id=3815f4cc&"
import script from "./SurveyInfoSurveyPreference.vue?vue&type=script&lang=js&"
export * from "./SurveyInfoSurveyPreference.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports